import * as endpoints from './endpoints';

const CmsService = { ...endpoints };

export default CmsService;
export type {
  AlignmentInput, AlignmentCondition, EligibilityCheckInput, ReportKind, ReportingSubmissionInput,
  CmsSubmissionRow,
} from './endpoints';
